export const times_index = ['times.index']
export const times_create = ['times.create']
export const times_edit = ['times.edit']

export default [].concat(
    times_index,
    times_create,
    times_edit
)
